document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('.text-button-bar-sticky')
  const progressBar = document.querySelector(
    '#shopify-section-progress-bar-section'
  )

  if (stickyBar) {
    const { sectionId } = stickyBar.dataset
    const parentDiv = stickyBar.closest(`#shopify-section-${sectionId}`)
    if (progressBar) {
      parentDiv.classList.add('sticky', 'z-8')

      const updateSticky = function updateSticky() {
        const progressBarTop = getComputedStyle(progressBar).top
        const progressBarHeight = progressBar.getBoundingClientRect().height
        parentDiv.style.top = `calc(${progressBarTop} + ${progressBarHeight}px)`
      }
      updateSticky()

      const resizeObserver = new ResizeObserver(updateSticky)
      resizeObserver.observe(progressBar)
    } else {
      parentDiv.classList.add('sticky', 'top-header', 'z-8')
    }
  }
})
